import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { RouteComponentProps, useParams, withRouter } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { withStyles } from '@material-ui/core';

import { Location, selectLocationAvailabilityInitQuery } from './queries';

import styles from './styles';
import ViewAvailabilityComponent from '../../../../../components/Global/Location/Common/components/StepAvailability';
import { Dashboard } from '../../../../../layouts';
import ErrorBoundary from '../../../../../components/ErrorBoundary';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
  location_id: string;
}

const ViewLocationAvailability = (_props: Props): React.ReactElement => {
  const { organisation_id, location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
    organisation_id: '',
    organisation: {
      name: '',
    },
  });

  const { data: locationAvailabilityQuery } = useQuery(selectLocationAvailabilityInitQuery(location_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationAvailabilityQuery) {
      setLocation(locationAvailabilityQuery.locations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [locationAvailabilityQuery]);

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Organisations', link: '/admin/organisations' },
        { label: location.organisation?.name, link: `/admin/organisations/${organisation_id}` },
        { label: 'Locations', link: `/admin/organisations/${organisation_id}/locations` },
        { label: location.name, link: `/admin/organisations/${organisation_id}/locations/${location_id}` },
        { label: 'Availability', link: `/admin/organisations/${organisation_id}/locations/${location_id}/availability` },
      ]}>
      <ErrorBoundary>
        <ViewAvailabilityComponent classes={{}} location_id={location_id} organisation_id={location.organisation_id || organisation_id} />
      </ErrorBoundary>
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewLocationAvailability));
